import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

import { useAuth } from '../../providers/AuthProvider';

const RightRoute = ({ children, rights, routeRedirection, ...props }) => {
  const { hasAccess } = useAuth();
  const hasRight = rights ? hasAccess(rights) : true;

  return (
    <Route {...props}>
      {hasRight ? children : <Redirect to={{ pathname: routeRedirection }} />}
    </Route>
  );
};

RightRoute.propTypes = {
  children: PropTypes.node,
  rights: PropTypes.array,
  routeRedirection: PropTypes.string,
};

export default RightRoute;
